import { useMutation } from '@tanstack/react-query';
import { operations } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';
import useDataDog from '@/reporting/DataDog';

type CreateHandoffResponse = operations['createHandoff']['responses']['200']['content']['application/json'];

export type MonduHandoffNextAction = CreateHandoffResponse['data']['nextAction'];

export const isSafeHandoffRedirectUrl = (redirectUrl: string): boolean => {
  try {
    return new URL(redirectUrl).protocol === 'https:';
  } catch {
    return false;
  }
};

const useCreateMonduHandoff = () => {
  const { addError } = useDataDog();

  return useMutation({
    mutationKey: ['lending-opportunities', 'mondu', 'handoff'],
    mutationFn: async (): Promise<MonduHandoffNextAction> => {
      const response = await apiClient
        .post('api/supplier-experience/user/lending-opportunities/MONDU/handoffs')
        .json<CreateHandoffResponse>();
      const nextAction = response.data?.nextAction;

      if (nextAction?.kind !== 'redirect' || !nextAction.redirectUrl) {
        throw new Error('SEA returned an invalid Mondu handoff action');
      }

      return nextAction;
    },
    onError: (error: Error): void => {
      addError(error, { feature: 'useCreateMonduHandoff' });
    },
  });
};

export default useCreateMonduHandoff;
